import React from 'react';
import BrandLoader from './BrandLoader';
import './PageLoadingFallback.css';

/**
 * Page Loading Fallback Component
 * Shows the brand loader (large shield + the rotating per-module line) in the
 * main content area without blocking sidebar/header.
 * Use this as Suspense fallback for routes wrapped in AppLayout.
 *
 * `message` is optional: routes that name the page they are loading show it
 * above the module line; without one, the module line stands alone.
 */
const PageLoadingFallback = ({ message }) => (
  <div className="page-loading-fallback">
    <BrandLoader variant="shield" size="xl" message={message} line />
  </div>
);

export default PageLoadingFallback;
